import React from 'react';
import { Container, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { ActivityTimeline } from '../components/ActivityTimeline';
import { en } from '../translations/en';

export const Activities: React.FC = () => {
  const theme = useTheme();

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography 
        variant="h4" 
        component="h1" 
        gutterBottom
        sx={{ color: theme.palette.primary.main }}
      >
        {en.pages.activities}
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        {en.activities.description}
      </Typography>
      
      <ActivityTimeline />
    </Container>
  );
};